import React, { FC } from 'react';
import { TabletFilterInput } from './TabletFilterInput';
import { TabletFilterDateInput } from './TabletFilterDateInput';
import { TabletFilterOptionsList, SelectedItem } from './TabletFilterOptionsList';
import { FilterOption } from './TabletFilterOptionsList';
import { DatesRangeValue } from '@mantine/dates';

export interface BaseFilterFieldProps {
  label?: string;
  className?: string;
}

export interface TextFilterFieldProps extends BaseFilterFieldProps {
  type: 'text' | 'number';
  value: string | number;
  onChange: (value: string | number) => void;
  placeholder?: string;
  variant?: 'default' | 'compact';
  min?: number;
  max?: number;
}

export interface DateFilterFieldProps extends BaseFilterFieldProps {
  type: 'date' | 'dateRange';
  value: Date | null | DatesRangeValue;
  onChange: (value: any) => void;
  placeholder?: string;
}

export interface SelectFilterFieldProps extends BaseFilterFieldProps {
  type: 'select';
  options: FilterOption[];
  selectedValues: SelectedItem[];
  onChange: (values: SelectedItem[]) => void;
  searchPlaceholder?: string;
  showSearch?: boolean;
}

export type FilterFieldProps =
  | TextFilterFieldProps
  | DateFilterFieldProps
  | SelectFilterFieldProps;

export const TabletFilterField: FC<FilterFieldProps> = (props) => {
  const { className } = props;
  return (
    <div className={className}>
      {(props.type === 'text' || props.type === 'number') && (
        <TabletFilterInput
          type={props.type}
          value={props.value}
          onChange={props.onChange}
          placeholder={props.placeholder}
          variant={props.variant}
          min={props.min}
          max={props.max}
        />
      )}

      {(props.type === 'date' || props.type === 'dateRange') && (
        <TabletFilterDateInput
          type={props.type === 'dateRange' ? 'range' : 'single'}
          value={props.value}
          onChange={props.onChange}
          placeholder={props.placeholder}
        />
      )}

      {props.type === 'select' && (
        <TabletFilterOptionsList
          options={props.options}
          selectedValues={props.selectedValues}
          onChange={props.onChange}
          searchPlaceholder={props.searchPlaceholder}
          showSearch={props.showSearch}
        />
      )}
    </div>
  );
};
